import { useQuery } from 'react-query';
import PraticalFieldService from 'curricula/pratical-field/services';

export function usePraticalField(praticalFieldId: number) {
  return useQuery(
    ['pratical-field', praticalFieldId],
    (key: string, id: number) =>
      id ? PraticalFieldService.get(id) : Promise.resolve(null),
    { refetchOnMount: false, refetchOnWindowFocus: false }
  );
}
